<script setup>
import { ref, watch, onMounted, nextTick, computed } from 'vue'
import Stepper from 'primevue/stepper'
import StepList from 'primevue/steplist'
import Step from 'primevue/step'
import { buySteps } from '~/utils/buyUtils'

const step = defineModel('step', {
  type: String,
  default: () => '1'
})

const props = defineProps({
  steps: {
    type: Array,
    default: () => null
  },
  stepLabel: {
    type: String,
    default: () => 'text'
  }
})

const stepperWrapperRef = ref()

const currentSteps = computed(() => {
  return props.steps || buySteps
})

function getStepLabel(item) {
  return item[props.stepLabel]
}

async function scrollToActiveStep() {
  await nextTick()

  const wrapper = stepperWrapperRef.value
  if (!wrapper) return

  const activeEl = wrapper.querySelector('.p-steplist .p-step.p-step-active')
  if (!activeEl) return

  const wrapperRect = wrapper.getBoundingClientRect()
  const activeRect = activeEl.getBoundingClientRect()

  wrapper.scrollLeft += (activeRect.left - wrapperRect.left) - wrapper.clientWidth / 2 + activeRect.width / 2
}

onMounted(scrollToActiveStep)
watch(step, scrollToActiveStep)
</script>

<template>
  <div ref="stepperWrapperRef" class="overflow-x-auto whitespace-nowrap px-3">
    <Stepper :value="step" class="min-w-max" linear>
      <StepList>
        <Step
          v-for="item in currentSteps"
          :key="item.value"
          :value="item.value"
        >
          {{ getStepLabel(item) }}
        </Step>
      </StepList>
    </Stepper>
  </div>
</template>

<style scoped>
.p-stepper {
  flex-wrap: nowrap !important;
}
</style>

